module.exports = __webpack_public_path__ + "img/layout-grey.22e6a95c.svg";